import clsx from 'clsx';
import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';

import styles from './style';
import Box from '../atomic/Box';
import Link from '../atomic/Link';
import AppBar from '../atomic/AppBar';
import Container from '../atomic/Container';
import IconButton from '../atomic/IconButton';
import useDesktop from '../../hooks/useDesktop';
import EditIcon from '../../assets/icons/Pencil';
import ArrowBackward from '../../assets/icons/ArrowBackward';
import useHeaderSnackbar from '../../hooks/useHeaderSnackbar';
import MenuHorizontalIcon from '../../assets/icons/MenuHorizontal';

const Header = ({
  classes,
  children,
  backLink,
  fullPage,
  maxWidth,
  className,
  style = {},
  bottomBorder,
  leftChildren,
  contextButtons,
  hidden = false,
  containerProps,
  onMenuIconClick,
  onEditIconClick,
  onBackButtonClick,
  upperHeader = null,
  position = 'sticky',
  middleContentCentered: passedMiddleContentCentered,
  ...props
}) => {
  const isDesktop = useDesktop();
  const { snackbarHeight } = useHeaderSnackbar();

  const [leftChildrenRef, setLeftChildrenRef] = useState(null);
  const [rightChildrenRef, setRightChildrenRef] = useState(null);

  const onNavButtonClick = (event) =>
    onBackButtonClick ? onBackButtonClick(event) : null;

  const iconButton = (
    <IconButton size="small" color="secondary" onClick={onNavButtonClick}>
      <ArrowBackward
        style={{ minWidth: '24px', maxHeight: '24px', maxWidth: '24px' }}
      />
    </IconButton>
  );

  const backButton = backLink ? (
    <Link to={backLink}>{iconButton}</Link>
  ) : (
    iconButton
  );

  const middleContentCentered = passedMiddleContentCentered || !isDesktop;

  const leftChildrenWidth =
    leftChildrenRef && leftChildrenRef.offsetWidth !== undefined
      ? leftChildrenRef.offsetWidth
      : 0;

  const rightChildrenWidth =
    rightChildrenRef && rightChildrenRef.offsetWidth !== undefined
      ? rightChildrenRef.offsetWidth
      : 0;

  const widestWidth =
    leftChildrenWidth > rightChildrenWidth
      ? leftChildrenWidth
      : rightChildrenWidth;

  const leftChildrenStyle = {
    marginRight: middleContentCentered
      ? `${widestWidth - leftChildrenWidth}px`
      : undefined,
  };

  const rightChildrenStyle = {
    display: 'flex',
    marginLeft: middleContentCentered
      ? `${widestWidth - rightChildrenWidth}px`
      : undefined,
  };

  const content = (
    <div className={classes.content}>
      <div style={leftChildrenStyle} ref={(ref) => setLeftChildrenRef(ref)}>
        {(onBackButtonClick || backLink) && !isDesktop && backButton}
        {leftChildren}
      </div>

      <div className={clsx('word-break', classes.children)}>{children}</div>

      <div style={rightChildrenStyle} ref={(ref) => setRightChildrenRef(ref)}>
        {onEditIconClick && (
          <Box mr={1}>
            <IconButton size="small" onClick={onEditIconClick}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>
        )}

        {onMenuIconClick && (
          <IconButton size="small" onClick={onMenuIconClick}>
            <MenuHorizontalIcon />
          </IconButton>
        )}

        {contextButtons}
      </div>
    </div>
  );

  return (
    <AppBar
      elevation={0}
      color="inherit"
      position={!fullPage && isDesktop ? 'static' : position}
      className={clsx(
        className,
        classes.header,
        hidden && classes.hidden,
        isDesktop && classes.isDesktop
      )}
      style={{ top: snackbarHeight, ...style }}
      {...props}
    >
      {upperHeader}

      {maxWidth === false ? (
        content
      ) : (
        <Container
          className={classes.marginLeftZero}
          maxWidth={maxWidth}
          {...containerProps}
        >
          {content}
        </Container>
      )}
    </AppBar>
  );
};

export default withStyles(styles)(Header);
